import StyledCheckbox from "../../../components/common/StyledCheckbox";

interface P {
  isSeedFrozen: boolean;
  setIsSeedFrozen: (isSeedFrozen: boolean) => void;
}

const LockSeedCheckbox = ({ isSeedFrozen, setIsSeedFrozen }: P) => {
  return (
    <StyledCheckbox 
      checked={isSeedFrozen}
      setIsChecked={setIsSeedFrozen}
      label="Freeze"
    />
  );
};

export default LockSeedCheckbox;
